module.exports = __webpack_public_path__ + "assets/montserrat-medium.c87ae77594115fce5261b0ed37497cf61cae657701735b83e7bf932a74cee413.woff";